import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { useMediaQuery } from 'react-responsive';
import { Link } from "react-router-dom";

import logo from "../Components/images/logo.png";
import logo1 from "../Components/images/logo1.jpeg";

const HomeCompoOne = () => {
  const [modalImage, setModalImage] = useState(null);
  const [images, setImages] = useState([]);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const openImage = (img) => setModalImage(img);
  const closeImage = () => setModalImage(null);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await fetch("https://dropshopi.com/api/all-uploads.php");
        const data = await res.json();
        if (data.status === "success") {
          const filtered = data.data.filter((img) => img.type === "Google");
          setImages(filtered.map((img) => img.image_path));
        }
      } catch (err) {
        console.error("Failed to fetch images", err);
      }
    };

    fetchImages();
  }, []);

  return (
    <>
      {/* Desktop View */}
      {!isMobile && (
        <div
          className="container-result d-flex flex-column justify-content-center align-items-center text-center px-3"
          style={{
            marginTop: "30px",
            paddingTop: "40px",
            paddingBottom: "20px",
          }}
        >
          <div className="text-center">
            <span className="comp1 mt-4 px-4 py-2 text-white">Results</span>
          </div>

          <h2 className="display-3 fw-bold anton ft3 mt-4" style={{ maxWidth: "1000px" }}>
            Results speak for <span className="text-warning">THEMSELVES.</span>
          </h2>

          <p className="mt-3 text-secondary fs-5" style={{ maxWidth: "750px" }}>
            From scrappy startups to scaling powerhouses,
            <br />
            we’ve driven real results for brands that demand more.
            <br />
            Across industries, our performance speaks louder than words — and the
            numbers back it up.
          </p>

          <div className="container-fluid scroll-container">
            <div className="scroll-wrapper d-flex">
              <div className="d-flex gap-3 group">
                {images.slice(0, 5).map((img, index) => (
                  <div className="case-card position-relative" key={index}>
                    <img
                      src={img}
                      className="card-bg"
                      onClick={() => openImage(img)}
                      style={{ cursor: "pointer" }}
                      alt={`Google image ${index + 1}`}
                    />
                  </div>
                ))}
                {images.slice(0, 5).map((img, index) => (
                  <div className="case-card position-relative" key={index}>
                    <img
                      src={img}
                      className="card-bg"
                      onClick={() => openImage(img)}
                      style={{ cursor: "pointer" }}
                      alt={`Google image ${index + 1}`}
                    />
                  </div>
                ))}

                {images.slice(0, 5).map((img, index) => (
                  <div className="case-card position-relative" key={index}>
                    <img
                      src={img}
                      className="card-bg"
                      onClick={() => openImage(img)}
                      style={{ cursor: "pointer" }}
                      alt={`Google image ${index + 1}`}
                    />
                  </div>
                ))}


                {images.slice(0, 5).map((img, index) => (
                  <div className="case-card position-relative" key={index}>
                    <img
                      src={img}
                      className="card-bg"
                      onClick={() => openImage(img)}
                      style={{ cursor: "pointer" }}
                      alt={`Google image ${index + 1}`}
                    />
                  </div>
                ))}

                {images.slice(0, 5).map((img, index) => (
                  <div className="case-card position-relative" key={index}>
                    <img
                      src={img}
                      className="card-bg"
                      onClick={() => openImage(img)}
                      style={{ cursor: "pointer" }}
                      alt={`Google image ${index + 1}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mobile View (Slider) */}
      {isMobile && (
        <div className="container px-2 py-2 text-center">
          <h2 className="fw-bold mb-3">Results</h2>

          <h2 className="display-3 fw-bold anton ft3 mt-4" style={{ maxWidth: "1000px" }}>
            Results speak for <span className="text-warning">THEMSELVES.</span>
          </h2>

          <p className="mt-3 text-secondary fs-5" style={{ maxWidth: "750px" }}>
            From scrappy startups to scaling powerhouses,
            <br />
            we’ve driven real results for brands that demand more.
            <br />
            Across industries, our performance speaks louder than words — and the
            numbers back it up.
          </p>

          <Slider {...sliderSettings}>
            {images.map((img, i) => (
              <div key={i} onClick={() => openImage(img)}>
                <img
                  src={img}
                  alt={`slide-${i}`}
                  className="img-fluid"
                  style={{ height: "200px", objectFit: "fill", margin: "0 auto" }}
                />
              </div>
            ))}
          </Slider>
        </div>
      )}

      {/* Lightbox Modal */}
      {modalImage && (
        <div className="fullscreen-modal" onClick={closeImage}>
          <span className="close-btn" onClick={closeImage}>
            &times;
          </span>
          <img
            src={modalImage}
            className="fullscreen-image"
            alt="Enlarged preview"
          />
        </div>
      )}
    </>
  );
};

export default HomeCompoOne;
